export const by = {
    header: {
        feedback: 'Электронны зварот',
        singIn: 'Уваход',
        logOut: 'Выхад',
        menuMain: 'Галоўная',
        menuDemotests: 'Дэма-Тэсты',
        menuStatistics: 'Статыстыка',
        personalAccount: 'Асабісты кабінет',
        about:'Аб платформе',
    },
    mainpage:{
        upperText: 'НАЦЫЯНАЛЬНАЕ ДАСЛЕДАВАННЕ ЯКАСЦІ АДУКАЦЫІ (НДЯА)',
        lowerText1: 'НДЯА ўключае: ',
        lowerText2:'- выкананне навучэнцамі тэставых заданняў для ўстанаўлення ўзроўню функцыянальнай пісьменнасці;',
        lowerText3:'- анкетаванне навучэнцаў;',
        lowerText4:'- анкетаванне законных прадстаўнікоў навучэнцаў;',
        lowerText5:'- анкетаванне педагогаў устаноў адукацыі;',
        lowerText6:'- анкетаванне адміністрацыі ўстаноў адукацыі.' ,
        lowerTextButton: 'Дэма-тэст',
        lastText: '2022 ГІАЦ Мінадукацыі',
        more:'Інфармацыя',
    },
    about:{
        centralText: 'Нацыянальнае даследаванне якасці адукацыі (НДЯА) - праграма ацэнкі функцыянальнай пісьменнасці навучэнцаў, якія маюць агульную базавую адукацыю. НДЯА вымярае здольнасць маладых людзей, якія знаходзяцца на этапе прафесійнага выбару, прымяняць веды, уменні і навыкі для вырашэння жыццёвых задач.',
        instruction:'Інструкцыя (.dox)',
        forTeacher:'Для арганізатараў НДЯА ва ўстановах адукацыі',
        forStudent:'Для навучэнцаў',
        forCurator:'Для каардынатараў',
        forExpert:'Для экспертаў',
        card1:'Чытацкая пісьменнасць',
        card1Text:'здольнасць чалавека разумець, выкарыстоўваць, ацэньваць тэксты, разважаць пра іх і займацца чытаннем, каб дасягаць сваіх мэт, пашыраць свае веды і ўдзельнічаць у сацыяльным жыцці.',
        card2:'Натуральна-навуковая пісьменнасць',
        card2Text:'гэта здольнасць чалавека займаць актыўную грамадзянскую пазіцыю па грамадска значных пытаннях, звязаных з прыродазнаўчымі навукамі, і яго гатоўнасць цікавіцца прыродазнаўчымі ідэямі',
        card3:'Матэматычная пісьменнасць',
        card3Text:'гэта здольнасць чалавека думаць матэматычна, фармуляваць, ужываць і інтэрпрэтаваць матэматыку для рашэння задач у разнастайных практычных кантэкстах. Яна складаецца з паняцці, працэдуры і факты, а таксама прылады для апісання, тлумачэнні і прадказанні з\'яў.',
        card4:'Фінансавая пісьменнасць',
        card4Text:'спалучэнне дасведчанасці, ведаў, навыкаў, установак і паводзін, звязаных з фінансамі і неабходных для прыняцця разумных фінансавых рашэнняў, а таксама дасягненні асабістага фінансавага дабрабыту; набор кампетэнцый чалавека, якія ўтвараюць аснову для разумнага прыняцця фінансавых рашэнняў.',
    },
    feedback: {
        feedbackTitle: 'Электронны зварот',
        rools: 'Правілы карыстання поштай і г.д.',
        roolsAcceptMessage: 'Я згодзен з правіламі',
        enterEmail: 'Калі ласка, увядзіце ваш email',
        chooseTopic: 'Абярыце тэму',
        enterMessage: 'Увядзіце тэкст паведамлення',
        send: 'адправіць',
        admin: 'Для адміністратара',
        denis: 'Для Дзяніса',
        edit: 'Для рэдактара тэстаў',
        errorMessage: 'Падчас адпраўкі вашага паведамлення адбылася памылка. Паведамленне не адпраўлена',
        alertMessage: 'Ваша паведамленне паспяхова адпраўлена',
        addMessage: 'Даданне паспяхова выканалася',
        address: 'Адрас',
        city: 'г. Мінск',
        street: 'вул. Казінца 4',
        number: 'Тэлефон',
        addFile:'Дадаць файл'

    },
    authorization: {
        mainText: 'НАЦЫЯНАЛЬНАЕ ДАСЛЕДАВАННЕ ЯКАСЦІ АДУКАЦЫІ (НДЯА)',
        authorizationTitle: 'Аўтарызацыя',
        enterLogin: 'Увядзіце лагін',
        enterPassword: 'Увядзіце пароль',
        button: 'Увайсці',
        passErr: 'Няправільны лагін',
        logErr: 'Няправільны пароль',

    },
    demotest: {
        title: 'Тэст 1',
        questionOne: 'Што капейка беражэ? Рубель; Еўра; Долар.',
        questionTwo: 'Манеты якога наміналу выкарыстоўваюцца ў Рэспубліцы Беларусь? 10 рублёў; 1 рубель ; 2 рублі; 5 рублёў.',
        questionThree: 'Вы знайшлі чамадан з грашыма. Вашы дзеянні?',
        questionFour: 'Мама дала Вані 10 рублёў, а тата яшчэ 20% ад колькасці, якой дала мама. Колькі грошай далі бацькі Вані?',
        previousQuestion: 'Папярэдняе пытанне',
        nextQuestion: 'Наступнае пытанне',
        completeTest: 'Завяршыць тэст',
        messegeAfterFinishedTest: 'Вынік паспяхова адпраўлены',
    },
    RoleIdOne: {
        buttonStartTesting: 'Пачаць тэставанне',
        buttonStatistics: 'Статыстыка',
        subordinates: 'Падначаленыя',
        addNewOrganization: 'Дадаць новую арганізацыю',
        enterName:'Увядзіце назву',
        importButton: 'Імпарт',
        message:'Паведамлення',
        showAllPost:'Паказаць усе паведамленьні',
        headerNew: 'Асабісты кабінет',
        headerMenuExit: 'Выйсці',
        additionalInformation:'Дад. інфармацыя',
        AddFieldsToFill:'Дадайце палі для запаўнення праз дроб (" / ")',
        enter:'Увядзіце',
        buttonAdd:'Дадаць',
        edit:'Рэдагаваць',
        buttonStart:'Запусціць',
        buttonEnd:'Спыніць',
        tests:'Тэсты',
        clearDatabase:'Ачысціць базу дадзеных',
        buttonYes:'Так',
        buttonNo:'Не',
        delete:'Выдаліць',
        update:'Змяніць',
        selectRole:'Абярыце ролю',
        curator:'Каардынатар раённы/рэгіянальны',
        teacher:'Арганізатар НДЯА ва ўстанове адукацыі',
        expert:'Эксперт',
        editor:'Рэдактар',
        addNewSubordinate:'Дадайце новага падпарадкаванага',
        FIO:'Прозвішча, імя',
        login:'Лагін',
        loginExample:'Прыклад лагіна',
        import:'Імпарт',
        class:'клас',
        send:'Адправіць',
        instructions:'Інструкцыі',
        start:'Запуск',
        demo:'Дэма',
        checking:'На праверку',
    },
    RoleIdTwo: {
        titleName: 'Настаўнік 1',
        students: 'Навучэнцы',
        buttonStatistics: 'Статыстыка',
        importButton: 'Імпарт',
        edit:'Рэдакітаваць',
        add:'Дадаць',
        enter:'Увядзіце',
        delete:'Выдаліць',
        buttonYes:'Так',
        buttonNo:'Не',
        change:'Змяніць',
        FIO:'Прозвішча, імя',
        login:'Лагін',
        class:'клас/курс',
        AddNewStudent:'Дадайце новага навучэнца',
        settings:'Налады',
    },
    RoleIdThree: {
        title: 'Выберыце неабходнае',
        questionnaireButton: 'Анкеты',
        createTestButton: 'Стварыць тэст/анкету',
        createTaskButton: 'Стварыць заданне',
        createQuestionButton: 'Стварыць пытанне',
        createTextButton: 'Стварыць тэкст',
        createFilterManagementButton: 'Упраўленне фільтрамі',
        followingTests: 'Даступныя наступныя тэсты:',
        addTestButton: 'Дадаць новы тэст',
        createTestDiscipline: 'Дысцыпліна',
        createTestComplexity: 'Складанасць',
        createTestButtonFind: 'Знайсці',
        createTestNameOfTheTest: 'Назва',
        createTestDescriptionTest: 'Апісанне',
        createTestQuestionnaire: 'Анкета',
        createTestTest: 'Тэст',
        createTestCompletionTime: 'Час праходжання тэсту (у хвілінах)',
        howManyPoint: 'Колькі балаў за пытанне',
        createTestQuestionsTest: 'Пытанні тэсту',
        sendButton: 'Адправіць',
        createTaskTitle: 'Канструктар пытання',
        createTaskСhangeToTheComplexTaskConstructor: 'змяніць на канструктар комплекснага задання',
        createTextConstructor:'Канструктар тэкстаў',
        createTaskCreateQuestion: 'Стварэнне пытання',
        createTaskClear: 'ачысціць',
        createTaskMakeQuestion: 'Стварыць пытанне',
        createTaskType: 'Тып',
        createTaskQuestion: 'Пытанне',
        createTaskQuestionText: 'тэкст пытання',
        createTaskTheQuestionText: 'тэкст умовы',
        createTaskButtonAddResponseOption: 'Дадаць варыянт адказу',
        createTaskButtonDeleteAnswerOption: 'Знішчыць варыянт адказу',
        createTaskAnswers: 'Адказы',
        answer:'адказ',
        textAnswer:'Тэкст адказу',
        createTaskTypeText: 'Тэкст',
        createTaskTags: 'Тэгі',
        createTaskButtonDiscipline: 'Дысцыпліна',
        createTaskButtonComplexity: 'Складанасць',
        createTaskExplanation: 'Тлумачэнне',
        createTaskTextOfTheExplanationToTheAnswers: 'Тэкст тлумачэнні да адказаў',
        createTasksendButton: 'Адправіць',
        createTextSendButton:'Адправіць тэкст',
        updateTextSendButton:'Рэдагаваць тэкст',
        createTaskComplexTaskConstructor: 'Канструктар комплекснага задання',
        createTaskButtonChangeToTaskConstructor: 'Змяніць на канструктар задання',
        createTaskGeneralCondition: 'Агульная ўмова',
        createTaskButtonSelectQuestion: 'Выбраць пытанне',
        createTaskButtonCreateQuestion: 'Стварыць пытанне',
        createTaskButtonSave: 'Захаваць комплекснае заданне',
        blockTest:'Блокі тэстаў',
        questions:'Пытанні',
        texts:'Тэксты',
        TextsForAComplexTask:'Тэксты да комплекснага задання',
        questionsOfAComplexTask:'Пытанні комплекснага задання',
        filterCreateCategory: 'Стварыць катэгорыю',
        chooseTypeQuestion:'Абярыце тып пытання',
        choiceOfOneOption: 'Выбар аднаго варыянту',
        multipleChoice:'Выбар некалькіх варыянтаў',
        longAnswer:'Доўгі адказ',
        shortAnswer:'Кароткі адказ',
        associations:'Асацыяцыі',
        omissionsInTheText:'Пропускі ў тэксце',
        sequencing:'Складанне паслядоўнасці',
        withExplanation:'З тлумачэннем',
        transfer:'Перацягванне',
        table:'Табліца',
        variety:'З варыятыўнасцю',
        addLine:'Дадаць радок',
        addColumn:'Дадаць слупок',
        addFile:'Дадаць файл',
        addFileText:`Каб дадаць файл
націсніце на кнопку
дадаць файл
ці перацягнеце патрэбны файл
у выдзеленую вобласць `,
        parameters:'Параметры',
        width:'шырыня',
        height:'вышыня',
        wrapping:'Абцяканне тэкстам'
    },
    RoleIdFour: {
        resault: 'Вынік',
        points:'Балаў',
        notCorrectAnswers:'Ня правільных адказаў',
        correctAnswers:'Правільных адказаў',
        edit:'Рэдагаваць',
        explanation:'Тлумачэнне',
        yourAnswer:'Ваш адказ',
        correctAnswer:'правільны адказ',
        availableForPassage: 'Даступныя для праходжання',
        textForAvailableTest: 'Няма даступных тэстаў',
        textForAvailableAnket: 'Няма даступных анкет',
        NoTestsPassed:'Няма пройдзеных тэстаў'
    },
    RoleIdFive: {
        subordinates: 'Падначаленыя вобласці',
        buttonEdit: 'Рэдагаваць',
        buttonSubmit:'Дадаць',
        textSubmit:'Дадаць новага падначаленага',
        fullNameText: 'Прозвішча, Імя ',
        fullNameTextEnter: 'Увядзіце прозвішча, імя ',
        login:'Лагін',
        loginEnter:'Увядзіце лагін',
        password:'Пароль',
        passwordEnter:'Увядзіце пароль',
        selectButton:'Вызначте са спісу',
        addButton:'Дадаць',
    },
    RoleIdSix: {
        questions:'Пытанні',
        question:'Пытанне',
        studentAnswer:'Адказ навучэнца',
        maxScore:'Максімальны бал',
        score:'Бал',
        send:'Aдправіць',
        enterNumberScore:'Увядзіце колькасць балаў',
        underReview:'На праверцы',
        verified:'Правераныя',
    },
     error:{
        errReturn: 'Вярнуцца на галоўную старонку',
        notFound: 'Старонка не знойдзена',
     },
     footer: {
        number: 'тэлефон для даведак: +375 25 000-0-00',
        mail: ' пошта: krisevich@giac.by',
        text: '©2020-2022 - Міністэрства адукацыі Рэспублікі Беларусь, ГІАЦ Мінадукацыі',
     },
    instructions: {
        next:'Далей',
    }

}
